export const RequirementsScreenLabels = {
    it: {
        home:`Home`,
        code:`Codice`,
        name:`Nome`,
        classification:`Classificazione`,
        status:`Status`,

        description:`Descrizione`,
        notes:`Note`,
        ok:`OK`,
        requirements:`Requisiti`,
        error:`Errore`,
        error_message:`Si è verificato un errore nell'accesso ai dati richiesti: {message}`,
        name_missing:`Il nome è mancante per l'elemento #{index}`,
        saving:`Salvataggio`,
        saving_data:`Salvataggio dei dati`,
        data_just_updated:`Dati aggiornati`,
        no_changes_after_last_save:`Non ci sono cambiamenti dopo l'ultimo salvataggio`,
        requirements_saved_with_success:`{count} requisiti salvati con successo`,
        success:`Dati salvati con successo`,
        action:`Azione`,
        point_of_attention:`Punto di attenzione`,
        aspect_to_be_considered:`Aspetto da considerare`,
        close:`Chiudi`,
        nameOfItem:`Nome dell'elemento`,
        codeOfItem:`Codice dell'elemento`,
        descriptionOfItem:`Descrizione dell'elemento`
   },
    
    en: {
       home:`Home`,
       code:`Code` ,
       name:`Name`,
       classification:`Classification`,
       status:`Status`,
       description:`Description`,
       notes:`Notes`,
       ok:`OK`,
       requirements:`Requirements`,
       error:`Error`,
       error_message:`An error occurred while accessing the requested data: {message}`,
       name_missing:`The name is missing for the item #{index}`,
       saving:`Saving`,
       saving_data:`Saving data`,
       data_just_updated:`Data just updated`,
       no_changes_after_last_save:`There are no changes after the last save`,
       requirements_saved_with_success:`{count} requirements saved with success`,
       success:`Data saved with success`,
       action:`Action`,
       point_of_attention:`Point of attention`,
       aspect_to_be_considered:`Aspect to be considered`,
       close:`Close`,
       nameOfItem:`Name of item`,
       codeOfItem:`Code of item`,
       descriptionOfItem:`Description of item`
    }
}; 